import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';
import { Endpoints } from '../enums/endpoints.enums';
import { IResponse } from '../interfaces/response.interface';
import { IResponseAuth } from '../interfaces/responseAuth.interface';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(
    private httpService: HttpService,
    private httpClient: HttpClient
  ) {}

  getCountries() {
    const url = environment.apiUrl + Endpoints.GET_COUNTRIES;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getRanges() {
    const url = environment.apiUrl + Endpoints.GET_RANGES;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getDocuments() {
    const url = environment.apiUrl + Endpoints.GET_DOCUMENTS;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  saveUser(request: any, file: any) {
    let formData: FormData = this.httpService.sendForm(request, file);
    const url = environment.apiUrl + Endpoints.SAVE_USER;
    const options = this.httpService.headerOptionsForm(true);
    return this.httpClient.post<any>(url, formData, options);

  }

  getUsers(userId?: number) {
    const url = environment.apiUrl + Endpoints.GET_USERS + (userId ? `/${userId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getClients(userId?: number) {
    const url = environment.apiUrl + Endpoints.GET_CLIENTS + (userId ? `/${userId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getStates() {
    const data = [
      {
        value: 1,
        label: 'Activo',
        class: 'bg-green',
        selected: false,
        isAdmin: false,
      },
      {
        value: 2,
        label: 'Potencial',
        class: 'bg-yellow',
        selected: false,
        isAdmin: false,
      },
      {
        value: 3,
        label: 'Seguimiento',
        class: 'bg-blue',
        selected: false,
        isAdmin: false,
      },
      {
        value: 4,
        label: 'Revisión',
        class: 'bg-blue-2',
        selected: false,
        isAdmin: false,
      },
      {
        value: 5,
        label: 'Inactivo',
        class: 'bg-red',
        selected: false,
        isAdmin: false,
      },
      {
        value: 6,
        label: 'En espera',
        class: 'bg-yellow',
        selected: false,
        isAdmin: true,
      },
      {
        value: 7,
        label: 'Sin requerimiento',
        class: 'bg-green',
        selected: false,
        isAdmin: true,
      },
      {
        value: 7,
        label: 'Más adelante',
        class: 'bg-green-4',
        selected: false,
        isAdmin: false,
      }
    ];
    return of(data);
  }

  saveCourse(request: any, file: File) {
    let formData: FormData = this.httpService.sendForm(request, file);
    const url = environment.apiUrl + Endpoints.SAVE_COURSE;
    const options = this.httpService.headerOptionsForm(true);
    return this.httpClient.post<any>(url, formData, options);
  }

  getCourses(courseId?: number){
    const url = environment.apiUrl + Endpoints.GET_COURSES + (courseId ? `/${courseId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  saveModule(request: any) {
    const url = environment.apiUrl + Endpoints.SAVE_MODULE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteCourse(request: any) {
    const url = environment.apiUrl + Endpoints.DELETE_COURSE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteModule(request: any) {
    const url = environment.apiUrl + Endpoints.DELETE_MODULE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteExamen(request: any) {
    const url = environment.apiUrl + Endpoints.DELETE_EXAMN;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  saveSession(request: any) {
    const url = environment.apiUrl + Endpoints.SAVE_SESSION;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getQuestions(itemId?:number){
    const url = environment.apiUrl + Endpoints.GET_QUESTIONS + (itemId ? `/${itemId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  saveHeadQuestion(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_HEAD_QUESTION;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  saveProduct(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_PRODUCT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getTypeQuestions(){
    const data = [
      {
          value: 1,
          state: false,
          label: 'Texto Libre',
          icon: 'assets/svg/Icon_editar.svg',
          iconSelected: 'assets/svg/Icon_editar_selected.svg'
      },
      {
          value: 2,
          state: false,
          label: 'Lista desplegable',
          icon: 'assets/svg/Icon_select.svg',
          iconSelected: 'assets/svg/Icon_select_selected.svg'
      },
      {
          value: 3,
          state: false,
          label: 'Opción única',
          icon: 'assets/svg/Icon_radio.svg',
          iconSelected: 'assets/svg/Icon_radio_selected.svg'
      },
      {
          value: 4,
          state: false,
          label: 'Casilla de verificación',
          icon: 'assets/svg/Icon_check.svg',
          iconSelected: 'assets/svg/Icon_check_selected.svg'
      }
    ]
    return of(data)
  }

  saveQuestion(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_QUESTION_EXAM;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteQuestion(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_QUESTION_EXAMEN;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getProducts(productId?:number){
    const url = environment.apiUrl + Endpoints.GET_PRODUCTS + (productId ? `/${productId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  deleteProduct(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_PRODUCT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteQuestionProduct(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_QUESTION_PRODUCT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  saveQuestionProduct(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_QUESTION_PRODUCT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  activeCourse(request:any){
    const url = environment.apiUrl + Endpoints.ACTIVE_COURSE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  activeProduct(request:any){
    const url = environment.apiUrl + Endpoints.ACTIVE_PRODUCT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getSalaries() {
    const url = environment.apiUrl + Endpoints.GET_SALARIES;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getHeritages() {
    const url = environment.apiUrl + Endpoints.GET_HERITAGES;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getIncomes() {
    const url = environment.apiUrl + Endpoints.GET_INCOMES;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  saveClient(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_CLIENT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getStatesClient(){
    const url = environment.apiUrl + Endpoints.GET_STATES_CLIENT;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  changeStateClient(request:any){
    const url = environment.apiUrl + Endpoints.CHANGE_STATE_CLIENT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  saveComment(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_COMMENT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  registerStartCourse(request:any){
    const url = environment.apiUrl + Endpoints.REGISTER_START_COURSE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  registerQuestionExamen(request:any){
    const url = environment.apiUrl + Endpoints.REGISTER_EXAMN_COURSE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  registerQuestionProduct(request:any){
    const url = environment.apiUrl + Endpoints.REGISTER_EXAMN_PRODUCT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  asignProducts(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_PRODUCTS_INTERESTED;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  saveDataFolder(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_FOLDER;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteFolder(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_FOLDER;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getFolders(folderId?:number){
    const url = environment.apiUrl + Endpoints.GET_FOLDERS + (folderId ? `/${folderId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  saveFileFolder(request: any, file:File){
    let formData: FormData = this.httpService.sendForm(request, file);
    const url = environment.apiUrl + Endpoints.SAVE_FILE_FOLDER;
    const options = this.httpService.headerOptionsForm(true);
    return this.httpClient.post<any>(url, formData, options);
  }

  savePoints(request:any){
    const url = environment.apiUrl + Endpoints.ADD_POINTS_AGENT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getPointsUser(userId: number, month:number, year: number){
    const url = environment.apiUrl + Endpoints.GET_DASHBOARD_USER + `/${userId}/${month}/${year}`;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  // downloadFile(fileUrl: string): Observable<Blob> {
  //   return this.httpClient.get(fileUrl, { responseType: 'blob' });
  // }

  getDashboardGeneral(month:number, year: number){
    const url = environment.apiUrl + Endpoints.GET_DASHBOARD_GENERAL + `/${month}/${year}`;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  getDashboardGraphic(year:number){
    const url = environment.apiUrl + Endpoints.GET_DASHBOARD_GRAPHIC + `/${year}`;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  deleteFile(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_FILE;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  saveDataTablet(request:any){
    const url = environment.apiUrl + Endpoints.SAVE_TABLET;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteTablet(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_TABLET;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getTablets(folderId?:number){
    const url = environment.apiUrl + Endpoints.GET_TABLETS + (folderId ? `/${folderId}` : '');
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  saveFileTablet(request: any, file:File){
    let formData: FormData = this.httpService.sendForm(request, file);
    const url = environment.apiUrl + Endpoints.SAVE_FILE_TABLET;
    const options = this.httpService.headerOptionsForm(true);
    return this.httpClient.post<any>(url, formData, options);
  }

  deleteFileTablet(request:any){
    const url = environment.apiUrl + Endpoints.DELETE_FILE_TABLET;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  downloadFile(fileUrl: string, nombre: string) {
    return this.httpClient.get(fileUrl, { responseType: 'arraybuffer' })
  }

  getPlans(): Observable<IResponseAuth> {
    const url = environment.apiUrl + Endpoints.GET_PLANS;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options);
  }

  deleteUser(request: any) {
    const url = environment.apiUrl + Endpoints.DELETE_USER;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  deleteClient(request: any) {
    const url = environment.apiUrl + Endpoints.DELETE_CLIENT;
    const options = this.httpService.headerOptionsJson(true, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }
  
}
